/*
 * We now support both a Webflow plugin and a Tailwind Code plugin. This Context helps us determine which one to use.
 * Can use these hooks to conditionally setup logic.
 */

import React, {useContext, createContext, useEffect, useState} from 'react';
import {AstView} from 'rendition-core';

import {useLocation} from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export interface ProductContextState {
    mode: 'Rendition' | 'Rendition_Code';
    devMode: boolean;
}

const ProductContext = createContext<ProductContextState>({
    devMode: false,
    mode: 'Rendition',
});

export const ProductContextProvider: React.FC<React.PropsWithChildren<{view: AstView | null}>> = ({children, view}) => {
    const [devMode, setDevMode] = useState(false);
    const query = useQuery();

    useEffect(() => {
        function windowDevToggle() {
            setDevMode(true);
        }
        if (query.get('dev')) {
            setDevMode(true);
        }

        (window as any).hello = windowDevToggle;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ProductContext.Provider
            value={{
                mode:
                    view?.meta.compilerOptions.product === 'Code' || view?.meta.compilerOptions.tailWind
                        ? 'Rendition_Code'
                        : 'Rendition',
                devMode,
            }}
        >
            {children}
        </ProductContext.Provider>
    );
};

export const useProductContext = () => {
    return useContext(ProductContext);
};
